import {  Component, 
  forwardRef, 
  OnDestroy,
  OnInit,
  Input, 
  ChangeDetectionStrategy, 
} from '@angular/core';
import {  ControlValueAccessor, 
  NG_VALUE_ACCESSOR, 
  FormBuilder,
  FormGroup,          
  Validators,
  FormControl,
  NG_VALIDATORS
} from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { CertificationMainService } from 'src/app/core/services/certification-main.service';
import { LookupService } from 'src/app/core/services/lookup.service';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';
import { BaseDynamicForm } from 'src/app/core/services/base-dynamic-form';
import { DynamicFormService } from 'src/app/core/services/dynamic-form.service';
import { TransactionProfileService } from 'src/app/pages/transaction/services/transaction-profile.service';
import { TransactionService } from 'src/app/pages/transaction/services/transaction.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { UserProcessProfileService } from 'src/app/core/services/user-process-profile.service';
import { Subscription } from 'rxjs';

export interface empresaInfo {

  companyName: string;
  companyAddresses: string;
  primaryPhone: string;
  fax: string;
  contactName:string;
  companyCertificationNumber:string;

}

@Component({
  selector: 'prgov-empresa',
  templateUrl: './empresa.component.html',
  styleUrls: ['./empresa.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EmpresaComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => EmpresaComponent),
      multi: true,
    }
  ],
})
export class EmpresaComponent extends BaseDynamicForm implements ControlValueAccessor, OnDestroy, OnInit {
    @Input() public isLinear: boolean;
    @Input() public isReview: boolean;
    @Input() empresa: any = "";

    form1: FormGroup;
    genders: any;
    langKey: any = 'SELECTED_LANGUAGE';
    subscriptions: Subscription[] = [];
    profile: any;
    soliciter: any;
    solicitant:any;

    get value(): empresaInfo {
      console.log("this.form1.value")
      console.log(this.form1.value)
      return this.form1.value;
    }
  
    set value(value: empresaInfo) {
      this.form1.patchValue(value);
      this.onChange(value);
      this.onTouched();
    }

    constructor(    
        private route:ActivatedRoute,
        private router: Router,
        private formBuilder: FormBuilder,
        public dialog: MatDialog,
        private mainService: CertificationMainService,
        private matSnackBar: MatSnackBar,
        public translate: TranslateService,
        public lookupService: LookupService,
        public ls: LsHelperService, 
        public dynamicFormService: DynamicFormService,
        public transactionProfileService: TransactionProfileService,
        public transactionService: TransactionService,
        public authService: AuthService,
        public userProcessProfileService: UserProcessProfileService,

    ) { 
        super();  
        translate.use(this.ls.get(this.langKey));

        this.formQty = 1;
      
    }
    onChange: any = () => {};
    onTouched: any = () => {};

    writeValue(obj: any): void {
      if (obj) {
        this.value = obj;
      }    

      if (obj === null) {
        this.form1.reset();
      }
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn: any): void {
      this.onTouched = fn;
    }
      
    validate(formControl: FormControl) {
      var returnValue = null;

      if(!this.form1.valid){
        returnValue = { profile: { valid: false } };
      }

      console.log(this.form1.valid)

      return returnValue;
    }

    
    setDisabledState?(isDisabled: boolean): void {
      throw new Error('Method not implemented.');
    }

    ngOnInit() {

      this.isReview = this.mainService.certificationToShow ? true :  false;
      this.isLinear = this.mainService.certificationToShow ? false :  true;
    
      this.form1 = this.formBuilder.group({
        "companyName": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([])],
        "companyAddresses": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([])],
        "primaryPhone": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([])],
        "fax": [{value: '', disabled:this.dynamicFormService.isReadOnly}],
        "contactName": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([])],    
        "companyCertificationNumber": [{value: '', disabled:this.dynamicFormService.isReadOnly}, Validators.compose([])],
     
      });  
    
      this.subscriptions.push(
        this.form1.valueChanges.subscribe(value => {
         this.onChange(value);
         this.onTouched();
       })
      )
    } 
    ngOnDestroy() {
      this.subscriptions.forEach(s => s.unsubscribe());
    }  

    setValidators(locationType) {
      let state = locationType.get('State').value; 
      let country = locationType.get('Country').value; 

        if (locationType === 1) {
            state.setValidators(Validators.required)
            country.setValidators(null)
        } 
        else {      
            state.setValidators(null);
            country.setValidators(Validators.required)
        }
    }
}
